import { $host } from ".";

export const createPersonal = async (personalData) => {
    try {
        const { data } = await $host.post('api/personal', personalData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (error) {
        console.error("Error creating personal:", error);
        return error;
    }
};

export const fetchPersonals = async () => {
    try {
        const { data } = await $host.get('api/personal');
        return data;
    } catch (error) {
        console.error("Error fetching personals:", error);
        return error;
    }
};

export const fetchPersonal = async (id) => {
    try {
        const { data } = await $host.get('api/personal/' + id);
        return data;
    } catch (error) {
        console.error("Error fetching a personal:", error);
        return error;
    }
};

export const updatePersonal = async (id, updatedPersonal) => {
    try {
        const { data } = await $host.put('api/personal/' + id, updatedPersonal, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (error) {
        console.error("Error updating a personal:", error);
        return error;
    }
};

export const deletePersonal = async (id) => {
    try {
        const { data } = await $host.delete('api/personal/' + id);
        return data;
    } catch (error) {
        console.error("Error deleting a personal:", error);
        return error;
    }
};
